import { render, staticRenderFns } from "./manual-field.vue?vue&type=template&id=1facef24&scoped=true"
import script from "./manual-field.vue?vue&type=script&lang=js"
export * from "./manual-field.vue?vue&type=script&lang=js"
import style0 from "./manual-field.vue?vue&type=style&index=0&id=1facef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1facef24",
  null
  
)

export default component.exports